import * as React from "react"
import type { SVGProps } from "react"
const SvgMenuVertical = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={24}
    height={24}
    fill="currentColor"
    viewBox="0 0 24 24"
    {...props}
  >
    <path d="M12 20.13q-.62 0-1.06-.44a1.4 1.4 0 0 1-.44-1.06q0-.63.44-1.06.45-.45 1.06-.44.62 0 1.06.44t.44 1.06q0 .6-.44 1.06-.45.44-1.06.44m0-5.77q-.62 0-1.06-.44a1.4 1.4 0 0 1-.44-1.06q0-.62.44-1.06.45-.45 1.06-.44.62 0 1.06.44t.44 1.06q0 .61-.44 1.06-.45.44-1.06.44m0-5.77q-.62 0-1.06-.44a1.4 1.4 0 0 1-.44-1.06q0-.62.44-1.06.45-.45 1.06-.44.62 0 1.06.44.45.45.44 1.06 0 .61-.44 1.06-.45.45-1.06.44" />
  </svg>
)
export default SvgMenuVertical
